const SvgHsdLogo = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 48 48" {...props}>
    <path
      fill="#fff"
      d="m31.898 23.386-2.785 2.777a.654.654 0 0 0 0 .926l.464.464-3.25 3.24a.655.655 0 0 0 0 .927l2.786 2.776a.66.66 0 0 0 .93 0l3.249-3.24.465.463a.66.66 0 0 0 .929 0l2.785-2.777a.654.654 0 0 0 0-.926l-4.644-4.63a.66.66 0 0 0-.93 0m-.814 7.755a.16.16 0 0 1 0 .23l-1.394 1.39a.16.16 0 0 1-.23 0l-1.395-1.39a.16.16 0 0 1 0-.23l1.394-1.39a.16.16 0 0 1 .231 0z"
    />
    <path
      fill="#FF8500"
      d="M24.002 10.882c-3.208-3.198-8.156-4.096-12.158-1.98C5.18 12.43 4.277 20.85 9.141 25.7l14.396 14.353a.66.66 0 0 0 .93 0l2.784-2.777a.655.655 0 0 0 0-.926L12.982 22.122c-1.98-1.974-2.213-5.183-.366-7.28a5.265 5.265 0 0 1 7.668-.256l3.25 3.24a.66.66 0 0 0 .93 0l3.25-3.24a5.265 5.265 0 0 1 7.431 0 5.23 5.23 0 0 1 0 7.41l-1.859 1.853 3.715 3.704 1.858-1.854a10.457 10.457 0 0 0 0-14.817c-4.103-4.09-10.757-4.09-14.86 0z"
    />
  </svg>
);

export default SvgHsdLogo;
